import React from "react"
import { Badge as PrimeBadge } from "primereact/badge"

/**
 * @param {import('primereact/badge').BadgeProps} props
 * @returns {JSX.Element}
 */
const Badge = (props) => {
  return <PrimeBadge {...props} />
}

export default Badge
